// removed by extract-text-webpack-plugin
module.exports = {"communication":"Communication__communication","communicationContent":"Communication__communicationContent","title":"Communication__title","message":"Communication__message","ctaContainer":"Communication__ctaContainer","submitYes":"Communication__submitYes","submitNo":"Communication__submitNo","contactUs":"Communication__contactUs","disclaimer":"Communication__disclaimer","subDisclaimer":"Communication__subDisclaimer","growDotQello":"Communication__growDotQello","growDotBlue":"Communication__growDotBlue","growDotGolden":"Communication__growDotGolden"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Communication/Communication.scss
// module id = 1897
// module chunks = 0